export function UpsellMetabaseBanner() {
  // IAS overlay: no premium-plan promo CTAs. Short-circuits before the plugin
  // hook to avoid an unnecessary render + upsell-flow trigger.
  return null;
}
